import { c as _c } from "react/compiler-runtime";
import type { CreditRangeEnum } from '@cc-shopping/contracts/credit-cards-page/roundup/utils';
import { Box, Button } from '@mui/material';
import { useShallow } from 'zustand/shallow';
import { CREDIT_RANGE_OPTIONS_LABEL_MAP } from '../../config';
import { useOffersFilterStore } from '../../store/Context';
import type { OffersFilterStoreState } from '../../store/types';
import type { FilterOption, MobileFilterCloseReason } from '../../types';
import { AppliedFiltersSummary } from './AppliedFiltersSummary';
import { CardFeatures } from './Filters/CardFeatures';
import { CreditRange } from './Filters/CreditRange';
import { Issuers } from './Filters/Issuers';
import { SortBy } from './Filters/SortBy';
import { Header } from './Header';
export function Container(t0) {
  const $ = _c(25);
  const {
    closeDialog
  } = t0;
  const {
    preComputedFilterOfferIds
  } = useOffersFilterStore(useShallow(_temp));
  let t1;
  if ($[0] !== preComputedFilterOfferIds.issuersIdNameMap) {
    t1 = Object.entries(preComputedFilterOfferIds.issuersIdNameMap).map(_temp2);
    $[0] = preComputedFilterOfferIds.issuersIdNameMap;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const issuersOptions = t1;
  let t2;
  if ($[2] !== preComputedFilterOfferIds.offersByRCSMap) {
    t2 = Object.entries(preComputedFilterOfferIds.offersByRCSMap).reduce(_temp3, []);
    $[2] = preComputedFilterOfferIds.offersByRCSMap;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const creditRangeOptions = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "column",
      gap: "2rem"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== closeDialog) {
    t4 = <Header closeDialog={closeDialog} />;
    $[5] = closeDialog;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AppliedFiltersSummary />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      display: "flex",
      flexDirection: "column",
      gap: 3
    };
    t7 = <CardFeatures />;
    t8 = <SortBy />;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== issuersOptions) {
    t9 = <Issuers options={issuersOptions} />;
    $[11] = issuersOptions;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== creditRangeOptions) {
    t10 = <CreditRange options={creditRangeOptions} />;
    $[13] = creditRangeOptions;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <Box aria-label="Filter options" sx={t6}>{t7}{t8}{t9}{t10}</Box>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      position: "sticky",
      bottom: 0,
      "&:before": {
        content: "\"\"",
        position: "absolute",
        top: "calc(var(--filters-dialog-padding) * -1)",
        left: "calc(var(--filters-dialog-padding) * -1)",
        width: "calc(100% + var(--filters-dialog-padding) * 2)",
        height: "calc(100% + var(--filters-dialog-padding) * 2)",
        backgroundColor: "white",
        zIndex: -1
      }
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== closeDialog) {
    t13 = <Box sx={t12}><Button onClick={() => closeDialog({
        reason: "apply"
      })}>DONE</Button></Box>;
    $[19] = closeDialog;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13 || $[23] !== t4) {
    t14 = <Box sx={t3}>{t4}{t5}{t11}{t13}</Box>;
    $[21] = t11;
    $[22] = t13;
    $[23] = t4;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
}
function _temp3(acc, t0) {
  const [key, value] = t0;
  const typedKey = key as CreditRangeEnum;
  if (value.size > 0) {
    acc.push({
      label: CREDIT_RANGE_OPTIONS_LABEL_MAP[typedKey],
      value: typedKey
    });
  }
  return acc;
}
function _temp2(t0) {
  const [id, name] = t0;
  return {
    label: name,
    value: id
  };
}
function _temp(state) {
  return {
    preComputedFilterOfferIds: state.preComputedFilterOfferIds
  };
}